module.exports = __webpack_public_path__ + "static/media/feel-invigorated.b8b54ea5.jpg";